// Catalog: подсказки по режимам (книги, писатели, поэты). Всё про каталог в одном месте:
// данные, тексты и источник для подписи, быстрый поиск по каталогу без сети.
//
// Interface:
//   catalogFor(mode) → { items: Candidate[], attribution: { title, hint, source: [строка | {href, text}] } }
//   catalogMatches(mode, query, limit?) → Candidate[]   (source: 'Каталог', local: true)
//   matchCatalog(items, query, limit?) → Candidate[]    (то же для произвольного списка)
// Candidate — единая форма записи для каталога и результатов поиска: {title, sub, imgUrl, thumbUrl, source}.
// Инвариант: thumbUrl задан только вместе с imgUrl; записи без картинки — просто плитка.

import books from './catalog-data/books.js';
import writers from './catalog-data/writers.js';
import poets from './catalog-data/poets.js';

const norm = (t) => String(t).toLowerCase().replace(/ё/g, 'е').replace(/[^a-zа-я0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();

const GUARDIAN = 'https://www.theguardian.com/books/ng-interactive/2026/may/12/the-100-best-novels-of-all-time';

const CATALOG = {
  books: {
    items: books,
    attribution: {
      title: 'Не помню, что читал: подсказки',
      hint: 'Нажмите на книгу: она встанет в выбранную ячейку, выбор перейдёт к следующей пустой.',
      source: [
        'Список: ', { href: GUARDIAN, text: '100 лучших романов всех времён по версии The Guardian' },
        ', 12 мая 2026, голосование 172 авторов, критиков и учёных. Показаны 99 книг, на которых сходятся пересказы списка. Обложки из Apple Books и Open Library.',
      ],
    },
  },
  writers: {
    items: writers,
    attribution: {
      title: 'Не помню, кого читал: подсказки',
      hint: 'Нажмите на автора: он встанет в выбранную ячейку, выбор перейдёт к следующей пустой.',
      source: ['Авторы списка The Guardian «100 лучших романов всех времён» (12 мая 2026). Портреты из Википедии; у кого нет свободной фотографии, будет плитка с именем.'],
    },
  },
  poets: {
    items: poets,
    attribution: {
      title: 'Не помню, кого читал: подсказки',
      hint: 'Нажмите на поэта: он встанет в выбранную ячейку вместе с известным стихотворением (его можно изменить).',
      source: ['Подборка редакции: классики русской и мировой поэзии. Это не рейтинг. Портреты из Википедии.'],
    },
  },
};

export const catalogFor = (mode) => CATALOG[mode];

// Мгновенный поиск по каталогу: каждое слово запроса должно начинать какое-то слово названия или
// подписи (для слов от четырёх букв годится и вхождение). Сначала совпадения с начала названия.
export function matchCatalog(items, query, limit = 8) {
  const tokens = norm(query).split(' ').filter(Boolean);
  if (!tokens.length) return [];
  const out = [];
  items.forEach((b, i) => {
    const title = norm(b.title);
    const hay = `${title} ${norm(b.sub || '')}`.trim();
    const words = hay.split(' ');
    if (!tokens.every((t) => words.some((w) => w.startsWith(t)) || (t.length >= 4 && hay.includes(t)))) return;
    const s = (title.startsWith(tokens.join(' ')) ? 3 : 0) + (tokens.every((t) => title.split(' ').some((w) => w.startsWith(t))) ? 2 : 0);
    out.push({ s, i, it: { ...b, source: 'Каталог', local: true } });
  });
  return out.sort((a, b) => b.s - a.s || a.i - b.i).slice(0, limit).map((x) => x.it);
}

export const catalogMatches = (mode, query, limit = 6) => matchCatalog(CATALOG[mode].items, query, limit);
